import { onlineCityCode } from '../data/fakeCities';

const cities = window.city ? Object.values(window.city) : [];
cities.push({
  ID: '0',
  CODE: 'online',
  NAME: 'Online',
  KLADR: '7102000200000',
});

const dadataApiKey = process.env?.DADATA_API_KEY || '318c0272e1d69ceed262f4345982fc0bce695feb';
export const moscowKLADR = 7700000000000;

export function getCityNameByKLADR(KLADR) {
  return KLADR
    ? cities.find(city => Number(city.KLADR) === Number(KLADR)).NAME
    : null;
}

export function getCityKLADRByName(name) {
  return name
    ? cities.find(city => city.NAME === name)?.KLADR || onlineCityCode
    : null;
}

export function getCurrentCity() {
  return cities.find(city => city.CURRENT);
}

export const getCityNameByKLDARwithDadata = async string => {
  const response = await fetch(
    'https://suggestions.dadata.ru/suggestions/api/4_1/rs/findById/address',
    {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
        authorization: `Token ${dadataApiKey}`,
      },
      body: JSON.stringify({
        query: `${string}`,
        count: 1,
      }),
    },
  );
  const json = await response.json();
  return json?.suggestions[0]?.data.city || moscowKLADR;
};

export const getKLDARByCityNameWithDadata = async cityName => {
  const response = await fetch(
    'https://suggestions.dadata.ru/suggestions/api/4_1/rs/suggest/address',
    {
      method: 'POST',
      headers: {
        'content-type': 'application/json',
        accept: 'application/json',
        authorization: `Token ${dadataApiKey}`,
      },
      body: JSON.stringify({
        query: `город ${cityName}`,
        count: 1,
      }),
    },
  );
  const json = await response.json();
  return json?.suggestions[0]?.data.city_kladr_id || moscowKLADR;
};
